import msg from '@cdo/applab/locale';
import * as utils from '../utils';
import blockUtils from '../block_utils';
import {ApplabBlocks} from '@cdo/apps/applab/sharedApplabBlocks';
import {ApplabGoalBlocks} from '@cdo/apps/applab/sharedApplabGoalBlocks';
var tb = blockUtils.createToolbox;
var blockOfType = blockUtils.blockOfType;
var createCategory = blockUtils.createCategory;

/*
 * Configuration for all levels.
 */
var levels = {};
export default levels;

levels.simple = {
  requiredBlocks: [],
  scale: {
    snapRadius: 2
  },
  freePlay: true,
  toolbox: tb(
    '<block type="applab_container" inline="true"> \
        <value name="ID"><block type="text"><title name="TEXT">id</title></block></value> \
        <value name="HTML"><block type="text"><title name="TEXT">html</title></block></value></block>'
  ),
  startBlocks: '<block type="when_run" deletable="false" x="20" y="20"></block>'
};

levels.custom = {
  freePlay: true,
  editCode: true,
  sliderSpeed: 1,

  /**
   * This is the default set of functions available to us if the levelbuilder
   * leaves codeFunctions blank.
   * They are defined in Applab.rb, and generated into a static JS file via
   * generateSharedConstants.rb
   */
  codeFunctions: ApplabBlocks

  // "randomNumber_max": null, // DEPRECATED
};

levels.ec_simple = utils.extend(levels.custom, {});

levels.ec_goals = utils.extend(levels.custom, {
  codeFunctions: {...ApplabBlocks, ...ApplabGoalBlocks}
});

// Functions in Advanced category currently disabled in all levels:
/*
 "imageUploadButton": null,
 "container": null,
 "innerHTML": null,
 "setStyle": null,
 "getAttribute": null,
 "setAttribute": null,
 "setParent": null,
*/

levels.full_sandbox = {
  scrollbars: true,
  requiredBlocks: [],
  scale: {
    snapRadius: 2
  },
  softButtons: ['leftButton', 'rightButton', 'downButton', 'upButton'],
  minWorkspaceHeight: 1400,
  freePlay: true,
  toolbox: tb(
    createCategory(
      msg.catActions(),
      '<block type="applab_createHtmlBlock" inline="true"> \
          <value name="ID"><block type="text"><title name="TEXT">id</title></block></value> \
          <value name="HTML"><block type="text"><title name="TEXT">html</title></block></value></block>'
    ) +
      createCategory(
        msg.catControl(),
        blockOfType('controls_whileUntil') +
          '<block type="controls_for"> \
                          <value name="FROM"> \
                            <block type="math_number"> \
                              <title name="NUM">1</title> \
                            </block> \
                          </value> \
                          <value name="TO"> \
                            <block type="math_number"> \
                              <title name="NUM">10</title> \
                            </block> \
                          </value> \
                          <value name="BY"> \
                            <block type="math_number"> \
                              <title name="NUM">1</title> \
                            </block> \
                          </value> \
                        </block>' +
          blockOfType('controls_flow_statements')
      ) +
      createCategory(
        msg.catLogic(),
        blockOfType('controls_if') +
          blockOfType('logic_compare') +
          blockOfType('logic_operation') +
          blockOfType('logic_negate') +
          blockOfType('logic_boolean')
      ) +
      createCategory(
        msg.catMath(),
        blockOfType('math_number') +
          '<block type="math_change"> \
                          <value name="DELTA"> \
                            <block type="math_number"> \
                              <title name="NUM">1</title> \
                            </block> \
                          </value> \
                        </block>' +
          '<block type="math_random_int"> \
                          <value name="FROM"> \
                            <block type="math_number"> \
                              <title name="NUM">1</title> \
                            </block> \
                          </value> \
                          <value name="TO"> \
                            <block type="math_number"> \
                              <title name="NUM">100</title> \
                            </block> \
                          </value> \
                        </block>' +
          blockOfType('math_arithmetic')
      ) +
      createCategory(
        msg.catText(),
        blockOfType('text') +
          blockOfType('text_join') +
          '<block type="text_append"> \
                          <value name="TEXT"> \
                            <block type="text"></block> \
                          </value> \
                        </block>'
      ) +
      createCategory(msg.catVariables(), '', 'VARIABLE') +
      createCategory(msg.catProcedures(), '', 'PROCEDURE')
  ),
  startBlocks: '<block type="when_run" deletable="false" x="20" y="20"></block>'
};
